import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    products: [],
    orders: [],
  },
  mutations: {
    updateUser(state, user) {
      state.user = user
    },
    setProducts(state, prods) {
      state.products = prods
    },
    setOrders(state, orders) {
      state.orders = orders
    },
  },
  actions: {

  }
})
